/*
The fax_number format is CXXXYYYZZZZ, where C is the Country code, XXX is the area code, and YYYZZZZ is the seven-digit fax number. 
Provide the phone number in an internationalized format (i.e., +33489871146 instead of 0489871146 for a French phone number).
Fax number rules:
- Start using +
- Minimum 8 digits

The fax number must start with a '+' and contain at least 8 digits.
At least one digit for the country code and at least 7 digits for the fax number.
*/
export const FAX_NUMBER_REGEX = /^\+\d{8,}$/;
